import React, { useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom';
import Sidebar from '../Pages/Sidebar';
import Header from '../Pages/Header';
import CopyRight from '../Pages/CopyRight';
import ProcessLoader from '../Components/ProcessLoader';
import axios from 'axios';
import { PAY_URL } from '../../../BaseURL';
import toast from 'react-hot-toast';

const YearlyDetailReport = () => {

    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const [secondsElapsed, setSecondsElapsed] = useState(0);


    useEffect(() => {
        if (localStorage.getItem('PAY_USER_TOKEN') === null) {
            navigate("/user/login");
        }
    }, []);

    const formatTime = (seconds) => {
        const minutes = Math.floor(seconds / 60);
        const secondsPart = seconds % 60;
        return `${String(minutes).padStart(2, '0')}:${String(secondsPart).padStart(2, '0')}`;
    };

    const downloadReport = () => {
        setIsLoading(true);
        setSecondsElapsed(0);

        let startTime = Date.now();
        const interval = setInterval(() => {
            setSecondsElapsed(Math.floor((Date.now() - startTime) / 1000));
        }, 1000);

        const myurl = `${PAY_URL}/user/yearly-month-report-download`;
        const bodyFormData = new URLSearchParams();
        bodyFormData.append('firm_id', localStorage.getItem('PAY_USER_FIRM_ID'));
        bodyFormData.append('year_id', localStorage.getItem('PAY_USER_YEAR_ID'));
        bodyFormData.append("print_date", true);

        axios({
            method: "post",
            url: myurl,
            data: bodyFormData,
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
                Authorization: "Bearer " + localStorage.getItem('PAY_USER_TOKEN')
            },
        }).then((response) => {
            if (response.data.success) {
                const fileUrl = response.data.data.file;
                toast.success(response?.data?.message);
                window.open(fileUrl, '_blank');
            } else {
                toast.error(response?.data?.message);
            }
        }).catch((error) => {
            console.log(error, '!!');
            toast.error(error?.response?.data?.message || "Download failed!");
        }).finally(() => {
            clearInterval(interval);
            setIsLoading(false);
        });
    };

    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const handleOpen = () => {
        setIsSidebarOpen(!isSidebarOpen)
    }

    return (
        <div className={`main-wrapper ${isSidebarOpen ? 'slide-nav' : ''}`}>
            <Header handleOpen={handleOpen} />
            <Sidebar />

            <div className="page-wrapper">
                <div className="content container-fluid">
                    <div className="page-header">
                        <div className="row align-items-center">
                            <div className="col">
                                <h3 className="page-title user-title">Yearly Details Salary Report Management</h3>
                                <ul className="breadcrumb">
                                    <li className="breadcrumb-item"><Link to="/user/dashboard">Dashboard</Link></li>
                                    <li className="breadcrumb-item active">Yearly Details Salary Report Management</li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div className="row filter-row">
                        <div className="col-md-4 col-lg-4 col-sm-12 d-flex align-items-center">
                            <button
                                className="btn btn-success d-flex align-items-center gap-2 px-3 py-2"
                                type="button"
                                onClick={downloadReport}
                                disabled={isLoading}
                            >
                                {isLoading ? <ProcessLoader /> : <i className="fa-solid fa-download"></i>}
                                <span>Download</span>
                                {isLoading && <span className="badge bg-light text-dark">{formatTime(secondsElapsed)}</span>}
                            </button>
                        </div>
                    </div>


                    <CopyRight />
                </div>
            </div>
        </div>
    )
}

export default YearlyDetailReport